/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition, aniSpeed } from '../../utils/styles/general';



/* ++++++++++ --------------- EMOJI ICON : STYLES --------------- ++++++++++ */
export default {
    emojiicon: {
        borderRadius: pxToEm(12),
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: pxToEm(42),
        height: pxToEm(42),
        padding: replacePXinStringWithEM('7px 7px'),
        extend: hoverTransition(),
        '& img': {
            width: 'auto',
            maxHeight: '100%'
        },
        '&:hover': {
            transform: 'scale(1.2)'
        },
        '&.isActive': {
            '&-true': {
                background: 'rgba(129, 201, 255, 0.09)',
                border: '1px solid rgb(20, 148, 244)',
            }
        }
    }
};
